import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { submitWaterTestFormAsync, submitWaterTestFormAsyncBuilder } from './asyncRequests/submitWaterTestFormAsync';

export interface WaterTestFormState {
  formData: {
    name: string;
    email: string;
    address1: string;
    address2: string;
    city: string;
    state: string;
    zip: string;
    waterSource: 'well' | 'public';
    utility: string;
    newsletter: boolean;
    equipment: string[];
  };
  loading: boolean;
  success: boolean;
  error: {
    message: string;
    errors: Array<{
      field: string;
      message: string;
    }>;
  } | null;
  isSubmitted: boolean;
}

const initialState: WaterTestFormState = {
  formData: {
    name: '',
    email: '',
    address1: '',
    address2: '',
    city: '',
    state: '',
    zip: '',
    waterSource: 'public',
    utility: '',
    newsletter: false,
    equipment: []
  },
  loading: false,
  success: false,
  error: null,
  isSubmitted: false,
};

const waterTestFormSlice = createSlice({
  name: 'waterTestForm',
  initialState,
  reducers: {
    updateField: (state, action: PayloadAction<{ field: keyof WaterTestFormState['formData']; value: any }>) => {
      const { field, value } = action.payload;
      if( state.error && state.error.errors){
        const errorIndex = state.error?.errors.findIndex((error) => error.field === field)
        if (errorIndex !== -1) {
          state.error!.errors = state.error?.errors.splice(errorIndex, 1) || []
        }
      }
      (state.formData[field] as any) = value;
    },
    resetForm: () => initialState,
  },
  extraReducers: (builder) => {
    submitWaterTestFormAsyncBuilder(builder);
  },
});


export const WaterTestFormActions = {
  ...waterTestFormSlice.actions,
  submitWaterTestFormAsync,
};
export const WaterTestFormReducer = waterTestFormSlice.reducer;